import React from 'react';

import './Card23.css';

const Card23 = props => {
  return (
    <div className={`card23 ${props.className}`} style={props.style}>
      {props.children}
    </div>
  );
};

export default Card23;
